import {range} from 'lodash'
import React from 'react'
import {Consumer} from '../../context'
import './context-loader.styl'

export default function ContextLoader(props) {
  return (<Consumer>{ (context) => {
    const loading = context.loading[props.id]
    return (
      <div className={`${props.className} ${loading ? 'loading' : 'loaded'}`}>
        {loading && (
          <div className="mask">
            <div className="spinner">
              {range(12).map(key => (<div {...{key}} />))}
            </div>
          </div>)}
        {props.children}
      </div>
    )
  }}</Consumer>)
}
